(function () {
    angular.module("app").directive("sendTo", SendToDirective);
    function SendToDirective() {
        return {
            transclude: true,
            // eslint-disable-next-line angular/no-directive-replace
            replace: true,
            scope: {
                description: "@",
                descriptionFunction: "=",
                buttonText: "@",
                buttonTextFunction: "=",
                buttonClass: "@",
                iconState: "@",
                onSend: "=?",
                direction: "@"
            },
            template: `
                 <div id="sliderDiv" class="tab-panel" style="display: block; position: fixed; bottom: 50px; width: 300px; cursor:move; z-index:10; background-color:white; max-height: min-content;">
                    <i class="glyphicon " ng-class="iconState"></i>
                    <p>{{ Description() }}</p>
                    <button class="ng-scope btn" ng-class="buttonClass" ng-click="Send()" style="font-size: large; width: 250px; height: 100px;">
                        {{ Text() }}
                    </button>
                </div>
                `,
            link: function ($scope, element) {
                if (!angular.isDefined($scope.direction) || !$scope.direction || $scope.direction == "left") {
                    $(element).css("left", "-250px");
                    $(element).animate({ "left": "+=265px" }, "slow");
                }
                if ($scope.direction == "right") {
                    $(element).css("left", ($(window).width() + 250));
                    $(element).animate({ "left": ($(window).width() - 320) }, "slow");
                }
                $(element).draggable();
                $scope.slideUp = true;
                $scope.Send = () => { if (angular.isFunction($scope.onSend)) $scope.onSend(); };
                $scope.iconState = !$scope.iconState || $scope.iconState === "" ? "fa fa-thumbs-up" : $scope.iconState;
                $scope.buttonClass = !$scope.buttonClass || $scope.buttonClass === "" ? "btn-success" : $scope.buttonClass;

                $scope.Description = () => $scope.description ? $scope.description : $scope.descriptionFunction;
                $scope.Text = () => $scope.buttonText ? $scope.buttonText : $scope.buttonTextFunction;
            }
        };
    }
})();
